/* Body Collective cart drawer upgrades (2026-09-15). The drawer's HTML is replaced on every cart change,
   so state that must survive a re-render (previous fill, add-on order) lives on window. */
(() => {
  const state = window.__bcCart || (window.__bcCart = { fill: null, penDone: null, shipDone: null, order: null });

  class BcCartProgress extends HTMLElement {
    connectedCallback() {
      const to = parseFloat(this.dataset.fill) || 0;
      const pen = this.querySelector('.bc-progress__stop--pen');
      const ship = this.querySelector('.bc-progress__stop--ship');
      const penDone = pen?.classList.contains('is-done');
      const shipDone = ship?.classList.contains('is-done');
      // A stop that has just been reached gets one small pop, so the reward is noticed.
      // Apps (like the free pen gift) can re-render the drawer straight after, so the pop window lasts 1.5s.
      const now = Date.now();
      if (penDone && state.penDone === false) state.penNewUntil = now + 1500;
      if (shipDone && state.shipDone === false) state.shipNewUntil = now + 1500;
      if (penDone && now < (state.penNewUntil || 0)) pen.classList.add('is-new');
      if (shipDone && now < (state.shipNewUntil || 0)) ship.classList.add('is-new');
      // Animate from the last width the shopper saw, so adding an item visibly moves the line.
      if (state.fill !== null && state.fill !== to) state.fillFrom = state.fill, state.fillUntil = now + 800;
      if (state.fillUntil && now < state.fillUntil && state.fillFrom !== undefined) {
        this.style.setProperty('--bc-fill', state.fillFrom + '%');
        requestAnimationFrame(() => requestAnimationFrame(() => this.style.setProperty('--bc-fill', to + '%')));
      }
      state.fill = to; state.penDone = !!penDone; state.shipDone = !!shipDone;
    }
  }

  class BcCartAddons extends HTMLElement {
    connectedCallback() {
      const items = Array.from(this.querySelectorAll('[data-bc-addon]'));
      const count = parseInt(this.dataset.count, 10) || 3;
      const ids = items.map((li) => li.dataset.bcAddon);
      // Shuffle once per page load; new ids join at random positions, so picks stay put while the cart updates.
      if (!state.order) state.order = [];
      ids.forEach((id) => {
        if (!state.order.includes(id)) state.order.splice(Math.floor(Math.random() * (state.order.length + 1)), 0, id);
      });
      const firstRender = !this.hasAttribute('data-seen') && !state.addonsSeen;
      state.order.filter((id) => ids.includes(id)).slice(0, count).forEach((id, i) => {
        const li = items.find((el) => el.dataset.bcAddon === id);
        li.hidden = false;
        li.classList.add('is-shown');
        if (firstRender) { li.classList.add('is-in'); li.style.animationDelay = i * 70 + 'ms'; }
        this.querySelector('.bc-addons__list').appendChild(li);
      });
      state.addonsSeen = true;
      this.addEventListener('change', (e) => {
        const select = e.target.closest('[data-bc-addon-select]');
        if (!select) return;
        const li = select.closest('[data-bc-addon]');
        const opt = select.selectedOptions[0];
        li.querySelector('add-to-cart').dataset.variantId = select.value;
        li.querySelector('[data-bc-addon-price]').textContent = opt.dataset.price;
        const s = li.querySelector('[data-bc-addon-compare]');
        s.textContent = opt.dataset.compare || '';
        s.hidden = !opt.dataset.compare;
      });
    }
  }

  if (!customElements.get('bc-cart-progress')) customElements.define('bc-cart-progress', BcCartProgress);
  if (!customElements.get('bc-cart-addons')) customElements.define('bc-cart-addons', BcCartAddons);
})();
